/**
 * PDP 마케팅 섹션의 텍스트 링크(`Return and Refund` · `Learn More` · `Add More Badges`).
 *
 * 피그마 `Button/Small - Noto Sans Semibold (sm)` = 12/16 w600 ls.1 `blue-60`,
 * 컨테이너는 h40 — 글자는 작지만 **터치 타깃은 40** 이라는 뜻이라 `h-10` 을 유지한다.
 *
 * ⚠️ hover/focus 밑줄은 **색 외 단서**다. `blue-60`(#0F62FE) 대 본문 `coolgray-90` 은
 * 대비 ≈3.0:1 이라 색만으로는 링크임이 구분되지 않는다(WCAG 1.4.1). 기본 상태는
 * 피그마대로 밑줄 없이 두고, 상호작용 시에만 드러낸다.
 * `rounded-[44px]` 는 `focus-visible:ring-2`(box-shadow)의 링 모양을 pill 로 잡아준다.
 *
 * ⚠️ `mt-auto` 를 넣지 말 것 — 이 링크가 놓이는 카드들은 전부 `items-start` 라
 * 카드 높이가 콘텐츠 높이고, 밀어낼 남는 공간이 없다. 피그마도 CTA 를 정렬하지 않는다
 * (본문 줄 수가 달라 계단식으로 어긋나는 게 의도).
 */
export const PDP_TEXT_LINK =
  "inline-flex h-10 w-fit items-center rounded-[44px] text-sm font-600 tracking-[0.1px] text-blue-60 underline-offset-4 hover:underline focus-visible:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-60";
